export default {
  has_portal_form(form_entry) {
    return Boolean(form_entry?.form?.id);
  },
  has_portal_form_answers(form_entry) {
    return Boolean(form_entry?.answers?.length);
  },
  get_answer_base_profile_id(answer) {
    return answer?.base_profile?.id || answer?.base_profile_id || "unknown";
  },
  get_answer_row_profile(answer) {
    return ({
      user: answer?.base_profile?.user || answer?.user || {},
      base_profile_id: this.get_answer_base_profile_id(answer),
      base_profile: answer?.base_profile || {},
    });
  },
  get_portal_form_answer_groups(form_entry) {
    const answer_groups = new Map();

    for (const answer of form_entry.answers || []) {
      const base_profile_id = String(this.get_answer_base_profile_id(answer));

      if (!answer_groups.has(base_profile_id)) {
        answer_groups.set(base_profile_id, {
          profile: this.get_answer_row_profile(answer),
          answers: [],
        });
      }

      answer_groups.get(base_profile_id).answers.push(answer);
    }

    return answer_groups;
  },
  get_portal_form_answer_map(table, answers) {
    const answer_map = {};

    for (const answer of answers) {
      this.add_form_table_answer(table, answer_map, answer);
    }

    return answer_map;
  },
  add_portal_form_answer_rows(table, form_entry) {
    const answer_groups = this.get_portal_form_answer_groups(form_entry);

    for (const answer_group of answer_groups.values()) {
      const answer_map = this.get_portal_form_answer_map(table, answer_group.answers);
      this.add_form_table_row(table, answer_group.profile, answer_map);
    }
  },
  add_portal_form_table_entry(forms_map, form_entry) {
    if (!this.has_portal_form(form_entry)) {
      return;
    }

    const table = this.get_or_create_form_table(forms_map, form_entry, "portal");
    this.add_form_table_questions(table, form_entry);

    if (!this.has_portal_form_answers(form_entry)) {
      return;
    }

    this.add_portal_form_answer_rows(table, form_entry);
  },
  add_portal_form_table_entries(forms_map) {
    for (const form_entry of this.portal_forms_answers || []) {
      this.add_portal_form_table_entry(forms_map, form_entry);
    }
  },
  toggle_portal_answer_table(table_id) {
    this.expanded_portal_answer_table_id = this.expanded_portal_answer_table_id === table_id ? null : table_id;
    this.sync_datatables();
  },
  is_portal_answer_table_open(table_id) {
    return this.expanded_portal_answer_table_id === table_id;
  },
  get_portal_forms_answers(portalId = this.portal_id) {
    if (!portalId) {
      this.portal_forms_answers = [];
      return;
    }

    this.loading_portal_forms_answers = true;
    $.ajax({
      url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/filter_portal_question/`,
      method: "POST",
      data: JSON.stringify({ portal_id: portalId }),
      headers: {
        "Authorization": `Token ${this.getToken()}`,
        "Content-Type": "application/json",
      },
      success: (response) => {
        this.portal_forms_answers = Array.isArray(response.data) ? response.data : [];
      },
      error: (xhr) => {
        console.error(xhr.message);
      },
      complete: () => {
        this.loading_portal_forms_answers = false;
      },
    });
  },
};
